import { Box, Button } from '@mui/material';
import ArrowBackIosSharpIcon from '@mui/icons-material/ArrowBackIosSharp';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import { NameAndPrice } from './NameAndPrice';
import { batch, useDispatch, useSelector } from 'react-redux';
import allActions from '../../actions/product_builder';
import isArtworkDefault from '../../utils/isArtworkDefault';
import layout from '../../styles/layout.module.css';
import typography from '../../styles/typography.module.css';
import { createCompositeKey } from '../../utils/createCompositeKey';
export const IEMPicker = (props) => {
    const currentModel = useSelector((state) => state.rootReducer.currentModel.currentModel);
    const currentModelPOS = useSelector((state) => state.rootReducer.currentModel.pos);
    const price = useSelector((state) => state.rootReducer.iemPrice);
    const artwork = useSelector((state) => state.rootReducer.currentArtwork);
    const modelListCount = props.modelList.sortedList.length - 1;
    const shopifyModelList = useSelector((state) => state.shopifyReducer.ciems);
    const dispatch = useDispatch();
    let setArtwork = (pos) => {
        if (isArtworkDefault(artwork.leftArtwork.displayName)) {
            const key = createCompositeKey(artwork.leftArtwork.displayName);

            dispatch(
                allActions.artworkActions.setLeftArtwork(
                    props.modelList.sortedList[pos].artwork[key]
                )
            );
        }
        if (isArtworkDefault(artwork.rightArtwork.displayName)) {
            const key = createCompositeKey(artwork.rightArtwork.displayName);
            dispatch(
                allActions.artworkActions.setRightArtwork(
                    props.modelList.sortedList[pos].artwork[key]
                )
            );
        }
    };
    const findModel = (model) => {
        const shopifyModel = shopifyModelList.find((item) => item.title === model.name);
        return shopifyModel;
    };
    let forwardSlide = () => {
        if (currentModelPOS < modelListCount) {
            batch(() => {
                const nextShopifyModel = findModel(props.modelList.sortedList[currentModelPOS + 1]);

                dispatch(
                    allActions.modelActions.updateCurrentModel(
                        props.modelList.sortedList[currentModelPOS + 1]
                    )
                );
                setArtwork(currentModelPOS + 1);
                dispatch(allActions.modelActions.setCurrentPOS(currentModelPOS + 1));
                dispatch(allActions.priceActions.updateBasePrice(nextShopifyModel));
            });
        } else if (currentModelPOS === modelListCount) {
            batch(() => {
                dispatch(allActions.modelActions.updateCurrentModel(props.modelList.sortedList[0]));
                dispatch(allActions.priceActions.updateBasePrice(shopifyModelList[0]));
                setArtwork(0);
                dispatch(allActions.modelActions.setCurrentPOS(0));
            });
        }
    };

    let backwardSlide = () => {
        if (currentModelPOS > 0) {
            const nextShopifyModel = findModel(props.modelList.sortedList[currentModelPOS - 1]);
            console.log(nextShopifyModel);
            batch(() => {
                dispatch(
                    allActions.modelActions.updateCurrentModel(
                        props.modelList.sortedList[currentModelPOS - 1]
                    )
                );
                setArtwork(currentModelPOS - 1);
                dispatch(allActions.modelActions.setCurrentPOS(currentModelPOS - 1));
                dispatch(allActions.priceActions.updateBasePrice(nextShopifyModel));
            });
        } else if (currentModelPOS === 0) {
            const nextShopifyModel = findModel(props.modelList.sortedList[modelListCount]);
            batch(() => {
                dispatch(
                    allActions.modelActions.updateCurrentModel(
                        props.modelList.sortedList[modelListCount]
                    )
                );
                dispatch(allActions.priceActions.updateBasePrice(nextShopifyModel));
                setArtwork(modelListCount);
                dispatch(allActions.modelActions.setCurrentPOS(modelListCount));
            });
        }
    };

    return (
        <Box className={layout.containerIemPicker}>
            <Button
                disableRipple={true}
                onClick={backwardSlide}
                className={typography.iemPickerArrow}>
                <ArrowBackIosSharpIcon />
            </Button>
            <NameAndPrice currentModel={currentModel} price={price} width={props.width} />
            <Button
                disableRipple={true}
                onClick={forwardSlide}
                className={typography.iemPickerArrow}>
                <ArrowForwardIosSharpIcon />
            </Button>
        </Box>
    );
};
